/**
 * 获取当前操作系统
 * @param needExact，是否需要精确？不需要时精确是返回 pc, ios, android, unknow
 * @returns {string}
 */
const getPlatform = function (needExact) {
  let result = ''
  let ua = window.navigator.userAgent.toLowerCase()
  let p = window.navigator.platform
  let isWin = p.indexOf('Win') === 0
  let isMac = p.indexOf('Mac') === 0
  let isPC = isWin || isMac
  if (needExact) {
    if (isWin) result = 'win'
    else if (isMac) result = 'mac'
    else if (ua.indexOf('android') > -1) result = 'android'
    else if (ua.indexOf('iphone') > -1) result = 'iphone'
    else if (ua.indexOf('ipod') > -1) result = 'ipod'
    else if (ua.indexOf('ipad') > -1) result = 'ipad'
    else if (ua.indexOf('windows phone') > -1) result = 'wp7'
    else if (ua.indexOf('symbian') > -1) result = 'symbian'
    else if (ua.indexOf('blackberry') > -1) result = 'blackberry'
    else result = 'unknow'
  } else {
    if (isPC) result = 'pc'
    else if (/iphone|ipod|ipad/.test(ua)) result = 'ios'
    else if (ua.indexOf('android') > -1) result = 'android'
    else result = 'unknow'
  }
  return result
}

module.exports = getPlatform



// WEBPACK FOOTER //
// ./src/utils/getPlatform.js